export default __webpack_public_path__ + "static/media/video.5958b492.mp4";